import { BaseUseCase } from "../../UseCaseBase";
class ConsolidateUseCase extends BaseUseCase {
    constructor(familyTaggingRepo) {
        super();
        this.familyTaggingRepo = familyTaggingRepo;
    }
    async fetchResult(req) {
        return await this.familyTaggingRepo.getConsolidatedDetails(req);
    }
}
export default ConsolidateUseCase;
